var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tabler-icon-send",
    clipPath: "url(#clip0_176_140)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.22635 11.0003L19.3753 11.3923M9.22635 11.0003L7.42467 15.7818C7.39826 15.8453 7.39063 15.915 7.40268 15.9827C7.41474 16.0504 7.44598 16.1132 7.49268 16.1637C7.53939 16.2141 7.59961 16.2501 7.66617 16.2674C7.73273 16.2846 7.80284 16.2824 7.86817 16.2609L19.3753 11.3923M9.22635 11.0003L7.79881 6.09415C7.77737 6.02882 7.77514 5.9587 7.79238 5.89214C7.80962 5.82558 7.84561 5.76537 7.89607 5.71866C7.94653 5.67195 8.00934 5.64071 8.07704 5.62866C8.14473 5.6166 8.21446 5.62423 8.27795 5.65065L19.3753 11.3923",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_176_140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.6693,
    height: 15.6693,
    fill: "white",
    transform: "translate(11.499) rotate(47.2117)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.e475c494c6ab103a32a62484d10edd5d.svg";
export { ForwardRef as ReactComponent };